import { render } from "./DtfConfirmationModal.vue?vue&type=template&id=3c5a1aa6&scoped=true"
import script from "./DtfConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DtfConfirmationModal.vue?vue&type=script&lang=js"

import "./DtfConfirmationModal.vue?vue&type=style&index=0&id=3c5a1aa6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5a1aa6"]])

export default __exports__